import React, {Fragment, useState, useEffect} from "react";
import {Unity, useUnityContext} from "react-unity-webgl";
import {viewWorld, createWorldMonitoring, updateWorldMonitoring} from "api-v3";
import ProgressBox from "components/Canvas/ProgressBox";

function UnityRenderer({unityData}) {
  const {unityProvider, isLoaded, loadingProgression} = useUnityContext({
    loaderUrl: unityData?.loaderUrl,
    dataUrl: unityData?.dataUrl,
    frameworkUrl: unityData?.frameworkUrl,
    codeUrl: unityData?.codeUrl,
  });

  const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);
  const [loadingPercentage, setLoadingPercentage] = useState(Math.round(loadingProgression * 100));
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const pId = queryParams.get("pid");

  const getUserOs = () => {
    let userOs = navigator.userAgent.replace(/ /g, "").toLowerCase();

    if (userOs.indexOf("macintosh") !== -1) {
      return "mac";
    } else if (userOs.indexOf("window") !== -1) {
      return "window";
    } else if (userOs.indexOf("android") !== -1) {
      return "android";
    } else if (userOs.indexOf("iphone") !== -1) {
      return "ios";
    } else if (userOs.indexOf("ipad") !== -1) {
      return "ipad";
    } else {
      return "unknown";
    }
  };

  useEffect(() => {
    const updateDevicePixelRatio = () => setDevicePixelRatio(window.devicePixelRatio);
    const mediaMatcher = window.matchMedia(`screen and (resolution: ${window.devicePixelRatio}dppx)`);

    let monitorInterval;

    const startWorldMonitoring = async () => {
      const os = getUserOs();
      const response = await createWorldMonitoring({pid: pId, os: os, entryAt: Date.now()});
      if (response.code === 1) {
        localStorage.setItem("monitorId", response.data.id);
      }
    };

    const checkWorldMonitoring = () => {
      monitorInterval = setInterval(() => {
        const monitorId = localStorage.getItem("monitorId");

        if (monitorId) {
          updateWorldMonitoring({id: monitorId}, {lastResponsedAt: Date.now()});
        }
      }, 60000);
    };

    const updateWorldViewCount = () => {
      viewWorld({id: pId});
    };

    updateWorldViewCount();
    startWorldMonitoring();
    checkWorldMonitoring();

    mediaMatcher.addEventListener("change", updateDevicePixelRatio);

    return () => {
      if (monitorInterval) {
        clearInterval(monitorInterval);
      }
      mediaMatcher.removeEventListener("change", updateDevicePixelRatio);
    };
  }, []);

  useEffect(() => {
    setLoadingPercentage(Math.round(loadingProgression * 100));
  }, [loadingProgression]);

  useEffect(() => {
    if (isLoaded) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [isLoaded]);

  return (
    <Fragment>
      <div>
        {loading && <ProgressBox percentage={loadingPercentage} loaded={isLoaded} processName="UNITY_FETCH" />}
        <div style={{display: loading ? "none" : "block", width: "100vw", height: "100vh"}}>
          <Unity unityProvider={unityProvider} style={{width: "100vw", height: "100vh"}} devicePixelRatio={devicePixelRatio} />
        </div>
      </div>
    </Fragment>
  );
}

export default UnityRenderer;
